<template>
  <Container>
    <PageHeader :items="items" />

    <b-alert variant="success" v-if="response.success" dismissible show>{{ response.success[0] }}</b-alert>
    <b-alert variant="danger" v-if="response.errors" dismissible show>{{ response.errors[0] }}</b-alert>
    <div class="row mb-5">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Invite Staff</h4>
            <p>
              Enter the mail of the recipient here. He/she will receive a mail with a link to create his/her account and
              password
            </p>

            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <b-form @submit.prevent="handleSubmit(onInvite)">
                <b-form-group label="Email" label-for="email">
                  <ValidationProvider rules="required|email" v-slot="{ errors }">
                    <b-row>
                      <b-col sm="8" md="6" lg="5" class="mb-3">
                        <b-form-input id="email" v-model="employee.email" placeholder="Enter email"></b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-col>

                      <b-col sm="4" md="6" lg="7">
                        <b-button type="submit" variant="primary">
                          Invite
                          <i class="fa fa-user-plus"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                  </ValidationProvider>
                </b-form-group>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Employees</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length mb-3">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="mx-1" v-model="perPage" size="sm" :options="pageOptions"></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="table-responsive mb-0">
                <b-table
                  :items="employeeItems"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(actions)="row">
                    <b-dropdown variant="default" dropleft>
                      <template v-slot:button-content>
                        <i class="fas fa-bars"></i>
                        <i class="bx bx-caret-down"></i>
                      </template>

                      <b-dropdown-item>
                        <i class="fa fa-pencil-alt"></i>
                        Edit Permissions
                      </b-dropdown-item>

                      <b-dropdown-item
                        v-b-modal.remove-modal
                        @click="employee_id = row.item.id"
                        link-class="text-danger"
                      >
                        <i class="fa fa-trash"></i>
                        Remove
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
              </div>

              <b-modal id="remove-modal" title="Remove Employee" title-class="font-18">
                Are you sure you want to remove this employee?
                <template v-slot:modal-footer>
                  <b-button variant="secondary" @click="$bvModal.hide('remove-modal')">No</b-button>
                  <b-button variant="danger" @click="onRemove">Yes</b-button>
                </template>
              </b-modal>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { getEmployees, inviteEmployee, removeEmployee } from "@/store/api";

export default {
  page: {
    title: "Employees",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
    PageHeader,
  },

  data() {
    return {
      employee: {
        email: "",
      },
      employee_id: "",
      response: "",
      employees: [],
      items: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Employees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      fields: [
        { key: "name" },
        { key: "email" },
        { key: "type" },
        { key: "phone_number" },
        { key: "actions", tdClass: "text-right" },
      ],
    };
  },

  created() {
    getEmployees().then((response) => (this.employees = response));
  },

  mounted() {
    this.totalRows = this.items.length;
  },

  computed: {
    rows() {
      return this.employeeItems.length;
    },

    employeeItems() {
      return this.employees.map((employee) => {
        return {
          id: employee.id,
          name: `${employee.attributes.first_name} ${employee.attributes.last_name}`,
          email: employee.attributes.email,
          type: employee.attributes.employee_type,
          phone_number: employee.attributes.phone_number,
        };
      });
    },
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onInvite() {
      inviteEmployee(this.employee).then((response) => (this.response = response));
    },

    onRemove() {
      this.$bvModal.hide("remove-modal");
      removeEmployee(this.employee_id).then((response) => {
        this.response = response;
        let index = this.employees.findIndex((employee) => employee.id === this.employee_id);
        this.employees.splice(index, 1);
      });
    },
  },
};
</script>
